import * as yup from 'yup';

export const getValidationSchema = () =>
  yup.object({
    email: yup.string().email().required('Required'),
    password: yup.string().required('Required'),
  });

export default getValidationSchema;
